import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useUser from '../../auth/hooks';

const AdminRoute = ({ component: Component, ...rest }) => {
  const { user } = useUser();
  const isAdmin = user && user.isAdmin;
  if (!isAdmin) {
    return <Redirect to='/cabinet' />;
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        isAdmin ? <Component {...props} /> : <Redirect to='/login' />
      }
    />
  );
};

export default AdminRoute;
